import Https from 'https';
import { Constants } from 'constants';
import ConfigPath from 'configpath';

export async function fetchOrgDetails(dashboardId) {
  try {
    let url = Constants.URLs.CYBER_LIST_API;
    if (ConfigPath.API_PATH) {
      url = `${ConfigPath.API_PATH}${url}`;
    }
    if (dashboardId) {
      url = `${url}?dashboardId=${dashboardId}`;
    }
    const response = await Https.get(url);
    return response;
  } catch (error) {
    return error;
  }
}

export async function fetchMinimalUserBenchmark(comparisonFilters = {}) {
  try {
    let url = Constants.URLs.CYBER_MINIMUM_USER_BENCHMARK_API;
    if (ConfigPath.API_PATH) {
      url = `${ConfigPath.API_PATH}${url}`;
    }
    const response = await Https.post(url, comparisonFilters);
    return response;
  } catch (error) {
    return error;
  }
}

export async function fetchBenchmarkForKpi(
  dashboardId,
  comparisonFilters = {},
  kpiIds = Constants.DEFAULT_KPIS,
) {
  try {
    let url = Constants.URLs.CYBER_KPI_BENCHMARK_API;
    if (ConfigPath.API_PATH) {
      url = `${ConfigPath.API_PATH}${url}`;
    }
    if (dashboardId) {
      url = `${url}?dashboardId=${dashboardId}`;
    }
    const response = await Https.post(url, {
      kpiIds,
      orgDetailsMultiSelect: comparisonFilters,
    });
    return response;
  } catch (error) {
    return error;
  }
}

export async function postOrgDetails(data) {
  try {
    let url = Constants.URLs.CYBER_LIST_API;
    if (ConfigPath.API_PATH) {
      url = `${ConfigPath.API_PATH}${url}`;
    }
    const response = await Https.post(url, data);
    return response;
  } catch (error) {
    return error;
  }
}

export async function fetchSubIndustries(id) {
  try {
    let url = `${Constants.URLs.CYBER_SUBINDUSTRY_API}${id}`;
    if (ConfigPath.API_PATH) {
      url = `${ConfigPath.API_PATH}${url}`;
    }
    const response = await Https.get(url);
    return response;
  } catch (error) {
    return error;
  }
}

export async function postKpiDetail(data, dashboardId) {
  try {
    let url = Constants.URLs.CYBER_POST_KPI;
    if (ConfigPath.API_PATH) {
      url = `${ConfigPath.API_PATH}${url}`;
    }
    if (dashboardId) {
      url = `${url}?dashboardId=${dashboardId}`;
    }
    const response = await Https.post(url, data);
    return response;
  } catch (error) {
    return error;
  }
}

export async function fetchCohort(dashboardId, comparisonFilters = {}) {
  try {
    let url = Constants.URLs.CYBER_GET_COHORT;
    if (ConfigPath.API_PATH) {
      url = `${ConfigPath.API_PATH}${url}`;
    }
    if (dashboardId) {
      url = `${url}?dashboardId=${dashboardId}`;
    }
    const response = await Https.post(
      url,
      {
        ...comparisonFilters,
      },
    );
    return response;
  } catch (error) {
    return error;
  }
}

export async function getKpiList(dashboardId) {
  try {
    let url = Constants.URLs.CYBER_GET_KPI_LIST;
    if (ConfigPath.API_PATH) {
      url = `${ConfigPath.API_PATH}${url}`;
    }
    if (dashboardId) {
      url = `${url}?dashboardId=${dashboardId}`;
    }
    const response = await Https.get(url);
    return response;
  } catch (error) {
    return error;
  }
}

export async function generatePPTX(pptx) {
  try {
    const response = await Https.post(`${ConfigPath.DOCUMENT_SERVICE_PATH}/common/pptx-util/generate-pptx`, pptx);
    return response;
  } catch (error) {
    return error;
  }
}

export async function fetchPPTXDownloadData(userId, token) {
  try {
    let url = Constants.URLs.CYBER_PPTX_DATA;
    if (ConfigPath.API_PATH) {
      url = `${ConfigPath.API_PATH}${url}`;
    }
    if (userId) {
      url = `${url}?userId=${userId}`;
    }
    const response = await Https.get(url, {
      'x-app-secret': token,
    });
    return response;
  } catch (error) {
    return error;
  }
}

export async function getKpiResources() {
  try {
    let url = Constants.URLs.CYBER_RESOURCES;
    if (ConfigPath.API_PATH) {
      url = `${ConfigPath.API_PATH}${url}`;
    }
    const response = await Https.get(url);
    return response;
  } catch (error) {
    return error;
  }
}

export async function fetchTeamMembers(dashboardId) {
  try {
    let url = Constants.URLs.TEAM_MEMBERS;
    if (ConfigPath.API_PATH) {
      url = `${ConfigPath.API_PATH}${url}`;
    }
    if (dashboardId) {
      url = `${url}?dashboardId=${dashboardId}`;
    }
    const response = await Https.get(url);
    return response;
  } catch (error) {
    return error;
  }
}

export async function addTeamMember(payload, dashboardId) {
  try {
    let url = Constants.URLs.INVITE_TEAM_MEMBERS;
    if (ConfigPath.API_PATH) {
      url = `${ConfigPath.API_PATH}${url}`;
    }
    if (dashboardId) {
      url = `${url}?dashboardId=${dashboardId}`;
    }
    const response = await Https.post(url, payload);
    return response;
  } catch (error) {
    return error;
  }
}

export async function removeTeamMember(email, dashboardId) {
  try {
    let url = `${Constants.URLs.REMOVE_TEAM_MEMBER}?email=${email}`;
    if (ConfigPath.API_PATH) {
      url = `${ConfigPath.API_PATH}${url}`;
    }
    if (dashboardId) {
      url = `${url}&dashboardId=${dashboardId}`;
    }
    const response = await Https.delete(url);
    return response;
  } catch (error) {
    return error;
  }
}

export async function updateRole({ email, type, dashboardId }) {
  try {
    let url = Constants.URLs.UPDATE_ROLE_TEAM_MEMBER;
    if (ConfigPath.API_PATH) {
      url = `${ConfigPath.API_PATH}${url}`;
    }
    if (dashboardId) {
      url = `${url}?dashboardId=${dashboardId}`;
    }
    const response = await Https.post(url, { email, type });
    return response;
  } catch (error) {
    return error;
  }
}

export async function resendInvite({ email, dashboardId }) {
  try {
    let url = Constants.URLs.RESEND_INVITE;
    if (ConfigPath.API_PATH) {
      url = `${ConfigPath.API_PATH}${url}`;
    }
    if (dashboardId) {
      url = `${url}?dashboardId=${dashboardId}`;
    }
    const response = await Https.post(url, { email });
    return response;
  } catch (error) {
    return error;
  }
}

export async function getPeerDiscussion(dashboardId, kpiId) {
  try {
    let url = `${Constants.URLs.PEER_DISCUSSION}${kpiId}`;
    if (ConfigPath.API_PATH) {
      url = `${ConfigPath.API_PATH}${url}`;
    }
    if (dashboardId) {
      url = `${url}&dashboardId=${dashboardId}`;
    }
    const response = await Https.get(url);
    return response;
  } catch (error) {
    return error;
  }
}

export async function getOverallRR() {
  try {
    let url = Constants.URLs.OVERALL_RR;
    if (ConfigPath.API_PATH) {
      url = `${ConfigPath.API_PATH}${url}`;
    }
    const response = await Https.get(url);
    return response;
  } catch (error) {
    return error;
  }
}

export async function getDashboardDetails() {
  try {
    let url = Constants.URLs.DASHBOARD_DETAILS;
    if (ConfigPath.API_PATH) {
      url = `${ConfigPath.API_PATH}${url}`;
    }
    const response = await Https.get(url);
    return response;
  } catch (error) {
    return error;
  }
}
